import React, { useState } from 'react';
import { toast } from 'react-toastify';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose, onLoginSuccess }) => {
  const [isOTPView, setIsOTPView] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    e.stopPropagation(); // Prevent event bubbling
    setLoading(true);
    try {
      const response = await fetch("https://portal.virtualtriage.ca/api/v1/patient/auth/login/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          email,
          password,
          sender_id: "senderid",
          device_type: "web"
        })
      });

      const data = await response.json();

      if (response.ok) {
        // Store password temporarily for portal login
        sessionStorage.setItem("tempPassword", password);
        localStorage.setItem("authToken", data.token);
        setIsOTPView(true);
        toast.success("Please enter the OTP sent to your email");
      } else {
        toast.error(data.message || "Invalid credentials. Please try again.");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const handleOTPVerification = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setLoading(true);
    try {
      const response = await fetch("https://portal.virtualtriage.ca/api/v1/patient/auth/login-verification/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json"
        },
        body: JSON.stringify({
          email: email,
          otp: otp
        })
      });

      const data = await response.json();

      if (response.ok && data?.status) {
        // Store token and user data
        const userData = {
          email: email,
          token: data.token,
          timestamp: new Date().getTime()
        };
        
        localStorage.setItem("authToken", data.token);
        localStorage.setItem("userData", JSON.stringify(userData));
        
        // Clear temporary password
        sessionStorage.removeItem("tempPassword");
        
        toast.success("Login successful!");
        
        // Close modal and trigger success callback
        onClose();
        if (onLoginSuccess) {
          onLoginSuccess();
        }
      } else {
        toast.error(data.message || "Invalid OTP!");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error("Error verifying OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={(e) => e.stopPropagation()}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h2>{isOTPView ? 'Enter OTP' : 'Login'}</h2>
        
        {!isOTPView ? (
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <input
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading} style={{ backgroundColor: '#00a3bb', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px', cursor: 'pointer' }}>
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleOTPVerification}>
            <div className="form-group">
              <input
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                required
              />
            </div>
            <button className="login-submit-button" type="submit" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify OTP'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default LoginModal; 